















import {
  Vue, Component, Prop, Mixins, PropSync, Watch,
} from 'vue-property-decorator';
import { Doughnut } from 'vue-chartjs';
import ChartsUtil from '@/util/ChartUtils';
import Chart from 'chart.js';

@Component({})
export default class RestaurantsChart extends Mixins(Doughnut) {
  @PropSync('restaurantLists', {}) restaurantList!: any;

  @PropSync('marketSelected', {}) selectedMarket!: any;

  private chart: any;

  mounted() {
    this.generateChart(this.restaurantList);
  }

  public generateChart(conf: any) {
    const ctx: any = document.getElementById('partner-chart');
    const partnerLegendContainer = (this.$refs.partnerLegend as any);
    const partnerNoDataContainer = (this.$refs.partnerNoData as any);
    if (ctx) {
      if (!conf) {
        const config = this.getChartConfig(this.restaurantList);
        if (this.chart) {
          this.chart.data.datasets = config.datasets;
          this.chart.data.labels = config.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(config.chartLabels,
              config.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(partnerNoDataContainer, partnerLegendContainer);
        }
      } else {
        const chartConfig = this.getChartConfig(conf);
        if (this.chart) {
          this.chart.data.datasets = chartConfig.datasets;
          this.chart.data.labels = chartConfig.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(chartConfig.chartLabels,
              chartConfig.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(partnerNoDataContainer, partnerLegendContainer);
        }
      }

      const myLegendContainer: any = document.getElementById('partner-legend');
      myLegendContainer.innerHTML = this.chart.generateLegend();
      this.chart.update();
    }
  }

  public getChartConfig(list: any) {
    const { data } = list;
    const chartData = data.datasets[0]?.data;
    const chartLabels = data.labels;
    const datasets = [{
      backgroundColor: ['#287dde', '#a0c0f6'],
      data: chartData,
    }];
    return {
      chartLabels,
      datasets,
    };
  }

  @Watch('restaurantLists')
  checkPartnerList(val: any) {
    this.generateChart(val);
  }
}
